import {z} from 'zod';

export const PriceDynamicsEnumSchema = z.enum([
  'PRICE_DYNAMICS_FALLING',
  'PRICE_DYNAMICS_RISING',
  'PRICE_DYNAMICS_STABLE',
]);
export type PriceDynamicsEnum = z.infer<typeof PriceDynamicsEnumSchema>;
